export default "__VITE_PUBLIC_ASSET__881d428a__"